import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CreateOrderService {
  localData: any;
  localLanguage: any;
  role: any;
  payload: any;
  sapPlantPayload: any;
  hitPriceSimulation: boolean = false;
  isRocksUser: boolean = false;
  cartData: any;
  constructor(private http: HttpClient, private store: Store<any>) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data.authReducer;
        if (this.localData?.businessDetails?.is_rocks_user) {
          this.isRocksUser = true;
        } else {
          this.isRocksUser = false;
        }
        this.cartData = data?.cartReducer?.cartData;
        this.role = this.localData.userDetails?.role?.name;
        this.localLanguage = data?.authReducer?.localLanguage?.locale;
        this.hitPriceSimulation =
          this.localData?.userDetails?.settings_data?.ENABLE_PRICE_SIMULATION ||
          false;
      });
  }

  getData() {
    return this.localLanguage == 'ar-AE' ? 'ar-EG' : this.localLanguage;
  }

  private dataSource = new BehaviorSubject('delivery');
  showAccordion = this.dataSource.asObservable();

  private deliveryDataSource = new BehaviorSubject(false);
  deliveryForm = this.deliveryDataSource.asObservable();

  private payerApiDataSource = new BehaviorSubject(true);
  callPayerApi = this.payerApiDataSource.asObservable();

  setDeliveryFrom(data) {
    this.deliveryDataSource.next(data);
  }

  setData(data) {
    this.dataSource.next(data);
  }

  setPayerApi(data) {
    this.payerApiDataSource.next(data);
  }

  private errorDetection = new BehaviorSubject(false);
  showError = this.errorDetection.asObservable();

  setError(data: any) {
    this.errorDetection.next(data);
  }

  fetchPayers(data: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('type', data.type);
    if (this.role === 'store_manager') {
      queryParams = queryParams.append('ship_to_code', data.sap_code);
    } else if (this.role === 'payer') {
      queryParams = queryParams.append('payer_sap_code', data.sap_code);
    }

    let headers: HttpHeaders = new HttpHeaders();
    let fetch_url: any;
    if (this.isRocksUser && location.pathname == '/create-orders/aggregate') {
      fetch_url = this.localData?.allApiLinks?.rocks_fetch_payers_url?.href
    } else {
      fetch_url = `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/fetch_payers`
    }
    return this.http.get<any>(
      `${fetch_url}`,
      { params: queryParams, headers }
    );
  }

  fetchShipTo(data: any) {
    if (this.role === 'store_manager') {
      this.payload = {
        material_short_code: '',
        payer_sap_code: data.payerSapCode,
        ship_to_code: data.sap_code,
        type: data.type,
      };
    } else if (this.role === 'payer') {
      this.payload = {
        material_short_code: '',
        payer_sap_code: data.sap_code,
        type: data.type,
      };
    } else {
      this.payload = {
        material_short_code: '',
        payer_sap_code: data.payerSapCode,
        type: data.type,
      };
    }
    let headers: HttpHeaders = new HttpHeaders();
    let endPoint = 'fetch_partner_ship_tos';
    let fetch_url: any;
    if (this.isRocksUser &&  location.pathname == '/create-orders/aggregate') {
      fetch_url = this.localData?.allApiLinks?.rocks_fetch_partner_ship_tos_url?.href
    } else {
      fetch_url = `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/${endPoint}`
    }
    return this.http.post<any>(
      `${fetch_url}`,
      this.payload,
      { headers }
    );
  }

  fetchUserShipTo() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/sap_business_sites`
    );
  }

  fetchShipToInUser(data: any) {
    let payload = {
      material_short_code: '',
      payer_sap_code: data.payerSapCode,
      type: data.type,
    };
    let headers: HttpHeaders = new HttpHeaders();

    return this.http.post<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/ship_tos_list`,
      payload,
      { headers }
    );
  }

  fetchSapPlants(data: any) {
    // sap_code:this.sap_code,
    if (this.role === 'store_manager') {
      this.sapPlantPayload = {
        inco_term: data?.inco_term,
        ship_to_code: data.sap_code,
        material_short_code: '',
        payer_sap_code: data.payerSapCode,
        ship_to_sap_number: data.ship_to_sap_number,
        contract_number: data?.contract_number,
        type: data.type,
      };
    } else if (this.role === 'payer') {
      this.sapPlantPayload = {
        inco_term: data?.inco_term,
        material_short_code: '',
        payer_sap_code: data.sap_code,
        ship_to_sap_number: data.ship_to_sap_number,
        contract_number: data?.contract_number,
        type: data.type,
      };
    } else {
      this.sapPlantPayload = {
        inco_term: data?.inco_term,
        material_short_code: '',
        payer_sap_code: data.payerSapCode,
        ship_to_sap_number: data.ship_to_sap_number,
        contract_number: data?.contract_number,
        type: data.type,
      };
    }

    let headers: HttpHeaders = new HttpHeaders();
    let fetch_url: any;
    if (this.isRocksUser &&  location.pathname == '/create-orders/aggregate') {
      fetch_url = this.localData?.allApiLinks?.rocks_fetch_sap_plants_url?.href
    } else {
      fetch_url = `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/fetch_sap_plants`
    }
    return this.http.post<any>(
      `${fetch_url}`,
      this.sapPlantPayload,
      { headers }
    );
  }

  fetchBalance(data: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('payer_sap_code', data?.payer_sap_code);
    if (data?.currency) {
      queryParams = queryParams.append('currency', data.currency);
    }
    return this.http.get<any>(
      this.localData?.allApiLinks?.fetch_balance_url.href,
      { params: queryParams }
    );
  }

  fetchProducts(data: any, i: number, type?: string) {
    let payload = {
      contract_number: data?.ship_tos?.contract_number,
      inco_term: data?.incoTerm,
      material_short_code: '',
      page: 1,
      payer_sap_code: data?.payer?.payer_sap_code,
      plant_code: data?.plant?.plant_code,
      plant_name: data?.plant?.name,
      sap_contract_product_id: [],
      ship_to_sap_number: data?.ship_tos?.ship_to_sap_number,
      type: type ? type : 'cement',
    };
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept-Language', 'en-KE');
    let fetch_url: any;
    if (this.isRocksUser &&  location.pathname == '/create-orders/aggregate') {
      fetch_url = this.localData?.allApiLinks?.rocks_fetch_products_url?.href
    } else {
      fetch_url = `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/fetch_products`
    }
    return this.http.post<any>(
      `${fetch_url}?page=${i}`,
      payload,
      { headers }
    );
  }

  fetch_order_suggestions() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/fetch_order_suggestions`
    );
  }

  fetchAllProducts(data: any, i: number) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept-Language', 'en-KE');

    return this.http.post<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/fetch_products?page=${i}`,
      data,
      { headers }
    );
  }

  //place order
  placeOrder(data: any) {
    data['order_source'] = 'WebApp';
    data['order_timestamp'] = Math.floor(new Date().getTime() / 1000);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    console.log(data);
    let fetch_url: any;
    if (this.isRocksUser &&  location.pathname == '/create-orders/aggregate') {
      fetch_url = this.localData?.allApiLinks?.rocks_sap_digital_orders?.href
    } else {
      fetch_url = `${this.localData?.allApiLinks?.sap_digital_orders?.href}`
    }
    return this.http.post<any>(
      // `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/sap_digital_orders`,
      `${fetch_url}`,
      data,
      { headers }
    );
  }

  fetchPriceSimulation(data: any) {
    let headers: HttpHeaders = new HttpHeaders();

    let type = data?.sap_contract?.contract_type;

    return this.http.post<any>(
      type && type == 'ZCP' && this.hitPriceSimulation
        ? `${this.localData?.allApiLinks?.price_simulation_url.href}`
        : `${this.localData?.allApiLinks?.business?.href}/contract_price_check`,
      data,
      { headers }
    );
  }

  getSapDetails() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/is_sap_blocked`
    );
  }

  payment(data) {

    let paymentData = this.localData?.userDetails?.country?.locale !== 'en-PH' ? {
      email: data?.email,
      amount: data?.amount,
      order_type: data?.order_type,
      description: data?.description,
      redirect_url: `${window.location?.origin}/processing`,
      cancel_url: `${window.location?.origin}/processing?status=cancelled`,
      apiVersion: '81'
    } : data
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/payment_flutterwave`,
      paymentData
    );
  }
  addfav(fav: any) {
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/user_favourite_products`,
      fav
    );
  }
  refreshAPI(
  ) {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/refresh_contracts`
    );
  }
  fileAttachment(lr_order_number: any,filesattachment: any,remove_file_ids:any) {
    let formData = new FormData();
    formData.append('lr_order_numbers', JSON.stringify(lr_order_number)); 
    if (filesattachment) {
      let files: File[] = filesattachment;
      for (let i = 0; i < files.length; i++) {
        console.log(files[i],'ishaaq')
        formData.append(`files[${i}]`, files[i]);
      }
    }
    if (remove_file_ids && Array.isArray(remove_file_ids) && remove_file_ids.length > 0) {
      formData.append('remove_file_ids', remove_file_ids.join(',') + ',');
    } else {
      formData.append('remove_file_ids', ' '); 
    }
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/upload_order_file`,
      formData
    );
  }
    generateTimeArray(selectedDate: string): string[] {
    const selected = new Date(selectedDate);
    const now = new Date();
    const isToday = selected.toDateString() === now.toDateString();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const periods = ['AM', 'PM'];
    const timeSet = new Set<string>();

    for (const period of periods) {
      for (let hour = 0; hour < 12; hour++) {
        const adjustedHour = hour === 0 ? 12 : hour;
        const formattedHour = adjustedHour.toString().padStart(2, '0');

        for (let minute = 0; minute < 60; minute += 30) {
          const formattedMinute = minute.toString().padStart(2, '0');
          const fullHour = this.convertTo24Hour(adjustedHour, period);

          // Skip past times if today
          if (
            isToday &&
            (fullHour < currentHour || (fullHour === currentHour && minute < currentMinute))
          ) {
            continue;
          }

          timeSet.add(`${formattedHour}:${formattedMinute} ${period}`);
        }
      }
    }

    return Array.from(timeSet);
  }
  private convertTo24Hour(hour: number, period: string): number {
    if (period === 'PM' && hour !== 12) return hour + 12;
    if (period === 'AM' && hour === 12) return 0;
    return hour;
  }
}

